import { render, staticRenderFns } from "./materialSupplier-add-or-update.vue?vue&type=template&id=78864f0c&scoped=true"
import script from "./materialSupplier-add-or-update.vue?vue&type=script&lang=js"
export * from "./materialSupplier-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./materialSupplier-add-or-update.vue?vue&type=style&index=0&id=78864f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78864f0c",
  null
  
)

export default component.exports